import React from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import PropTypes from 'prop-types';
import CDU from 'control-cdu';
import { Icon, Label, Stack, Utils, Space } from 'mw-style-react';
import { APP_AUTH_KEY } from 'constants';
import 'control-cdu/dist/control-cdu.css';
import { useSelector } from 'react-redux';
import scss from './ScriptView.scss';

function getScriptWorkspace({ config, acc, app }) {
  const scripts = config.appSettings?.system_scripts || [];
  const findS = scripts.find((i) => i.ref === app);
  return findS ? findS.accId : acc;
}

function convertQueryObjToString(query) {
  const queryString = Object.keys(query)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`
    )
    .join('&');

  return queryString ? `?${queryString}` : '';
}

function convertQueryStringToObj(string = '') {
  if (!string) return {};
  const parsedString = string.split('?')[1];
  if (!parsedString) return {};
  const queryObj = {};
  parsedString
    .split('&')
    .map((pair) => pair.split('='))
    .forEach(([key, value]) => {
      queryObj[decodeURIComponent(key)] = decodeURIComponent(value);
    });

  if (Object.keys(queryObj).length === 0) {
    return {};
  }
  return queryObj;
}

function ScriptView({
  baseUrl,
  acc,
  app,
  stage,
  page: pageId,
  history,
  whiteLabel,
}) {
  const { search: searchStr } = useLocation();
  const searchObj = convertQueryStringToObj(searchStr);
  const config = useSelector((state) => state.config);
  const { widgetUrl } = useSelector((state) => state.config);
  if (!widgetUrl) return;
  if (document.title !== app) document.title = app;
  let currentPage = pageId;
  return (
    <ErrorBoundary
      FallbackComponent={({ error }) => (
        <Space size="medium">
          <Stack.H className={scss.error} fullWidth alignItems="center">
            <Icon type="alert" error />
            <Label value={error.message} />
          </Stack.H>
        </Space>
      )}
    >
      <div id="cdu" style={{ height: '100vh', display: 'flex' }}>
        <CDU
          auth={Utils.fromStorage(APP_AUTH_KEY)}
          workspace={getScriptWorkspace({ config, acc, app })}
          app={app}
          query={searchObj}
          stage={stage}
          page={pageId}
          whiteLabel={whiteLabel}
          onPageChange={({
            page: newPage,
            query: newQuery = {},
            silent = false,
          }) => {
            const search = convertQueryObjToString(newQuery);
            const path = `${newPage}${search}`;
            if (silent) {
              if (currentPage === newPage) {
                window.history.replaceState({}, '', path);
              } else {
                window.history.pushState({}, '', path);
              }
            } else {
              history.push(`${baseUrl}/${app}/${stage}/${path}`);
            }
            currentPage = newPage;
          }}
          widgetUrl={widgetUrl}
        />
      </div>
    </ErrorBoundary>
  );
}

ScriptView.propTypes = {
  baseUrl: PropTypes.string,
};

export default ScriptView;
